import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';

@Component({
  selector: 'fx-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.sass'],
})
export class PageHeaderComponent implements OnInit, OnDestroy {
  @Input() url: string;
  @Input() title: string;
  @Input() refreshButton: boolean;
  @Input() backButton: boolean;
  @Output() back = new EventEmitter<boolean>();
  @Input() printButton: boolean;
  @Output() print = new EventEmitter<boolean>();
  @Input() settingButton: boolean;
  @Output() setting = new EventEmitter<boolean>();
  subscription: any;
  myRoute: any;
  constructor(private router: Router) {
    // override the route reuse strategy
    this.router.routeReuseStrategy.shouldReuseRoute = () => {
      return false;
    };

    this.subscription = this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
        // trick the Router into believing it's last link wasn't previously loaded
        this.router.navigated = false;
        // if you need to scroll back to top, here is the right place
        window.scrollTo(0, 0);
      }
    });
  }

  ngOnInit(): void {}

  onRefresh(): void {
    this.router.navigate([this.router.url || '/app/dashboard']);
  }

  onPrint(): void {
    this.print.emit(true);
  }

  onSetting(): void {
    this.setting.emit(true);
  }

  onBack(): void {
    this.back.emit(true);
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
